export enum LocalStorageKey {
  AUTH_TOKEN = "AuthToken",
  FORMATS_STATE = "FormatsState",
}

export enum SessionActionType {
  SAVE = "SESSION_SAVE",
  DESTROY = "SESSION_DESTROY",
  RESTORE = "SESSION_RESTORE",
}
